import RefreshIcon from "@mui/icons-material/Refresh";
import {
  Alert,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Grid,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";
import ProjectExecutionPlanApi from "../../../../../infrastructure/api/projectExecutionPlan";
import { toJalaliFullDate } from "../../../../middleware/middleware";

const roleConfig = {
  Contractor: { label: "پیمانکار", path: "/SLN/Contractor" },
  Supplier: { label: "تامین‌کننده", path: "/SLN/Supplier" },
  Supervisor: { label: "ناظر", path: "/SLN/Supervisor" },
};

const MyExecutionMilestonesPage = ({ role = "Contractor" }) => {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [error, setError] = useState("");

  const config = roleConfig[role] || roleConfig.Contractor;

  const loadItems = async () => {
    setLoading(true);
    setError("");
    const res = await ProjectExecutionPlanApi.getMyExecutionMilestones(role);
    if (!res.ok) {
      setError(res.message || "خطا در دریافت مراحل اجرا");
      setItems([]);
    } else {
      setItems(Array.isArray(res.data) ? res.data : []);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadItems();
  }, [role]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <BreadcrumbsComponent
          items={[
            { title: "SLN", path: "/SLN" },
            { title: config.label, path: config.path },
            { title: "مراحل اجرای من" },
          ]}
        />
      </Grid>

      <Grid item xs={12}>
        <Card>
          <CardHeader
            title="مراحل اجرای من"
            subheader="نمایش read-only مراحل برنامه زمان‌بندی اجرا."
            action={
              <IconButton onClick={loadItems} disabled={loading}>
                <RefreshIcon />
              </IconButton>
            }
          />
          <CardContent>
            {error ? (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            ) : null}

            <Paper variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>درخواست</TableCell>
                    <TableCell>مرحله</TableCell>
                    <TableCell>نوع</TableCell>
                    <TableCell>بازه</TableCell>
                    <TableCell>وضعیت برنامه</TableCell>
                    <TableCell>وضعیت</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        {loading ? "در حال بارگذاری..." : "مرحله‌ای یافت نشد."}
                      </TableCell>
                    </TableRow>
                  ) : (
                    items.map((item) => (
                      <TableRow key={item.id}>
                        <TableCell>
                          <Typography variant="body2" fontWeight={600}>
                            {item.requestTitle || `درخواست ${item.requestId}`}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {item.requestReferenceId}
                          </Typography>
                        </TableCell>
                        <TableCell>{item.title}</TableCell>
                        <TableCell>{item.milestoneTypeTitle}</TableCell>
                        <TableCell>
                          <Typography variant="caption" display="block">
                            {item.plannedStartDate
                              ? toJalaliFullDate(item.plannedStartDate)
                              : "-"}
                          </Typography>
                          <Typography variant="caption" display="block">
                            {item.plannedEndDate
                              ? toJalaliFullDate(item.plannedEndDate)
                              : "-"}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Chip size="small" label={item.planStatusTitle || "-"} />
                        </TableCell>
                        <TableCell>
                          <Stack direction="row" spacing={0.5} flexWrap="wrap">
                            <Chip size="small" label={item.statusTitle || "-"} />
                            {item.isPaymentTrigger ? (
                              <Chip size="small" variant="outlined" label="Payment" />
                            ) : null}
                            {item.isProcurementTrigger ? (
                              <Chip size="small" variant="outlined" label="Procurement" />
                            ) : null}
                          </Stack>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </Paper>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default MyExecutionMilestonesPage;
